module.exports = __webpack_public_path__ + "static/media/gmail-send-correct.6d567df7.png";